import { Row, Col, Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Icons, Spinner } from "../../../../Constant";
import { FontawesomeCommonProp } from "../../../../Type/CommonComponant";

const FontawesomeCommon = ({ title, iconType, parentCallback }: FontawesomeCommonProp) => {
  const getItag = (tag: string) => parentCallback(tag);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={`${title} ${Icons}`} />
        <CardBody>
          <Row className="icon-lists">
            {iconType.map((icon, index: number) => (
              <Col sm="6" md="4" xl="3" key={index} onClick={() => getItag(icon)}>
                <i className={`fa ${title === Spinner ? "fa-spin" : ""} fa-${icon}`}></i> {"fa fa-"}{icon}
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FontawesomeCommon;
